import { useContext, useEffect } from "react";
import { SearchVehicleByParamsDataContext } from "../SearchVehicleByParamsDataProvider";
import { SearchVehicleByParamsDataContextType } from "../types";

/**
 * Переход на страницу поиска автомобиля по каталогу
 * @param {React.ReactNode} children - Дочерние компоненты
 * @returns {React.ReactNode}
 */
export const FindVehicle = ({ children }: { children: React.ReactNode }) => {
    const { vehicleId, brand, vehicleSsd } = useContext(SearchVehicleByParamsDataContext) as SearchVehicleByParamsDataContextType;

    useEffect(() => {
        if (vehicleId && brand && vehicleSsd) {
            document.location = `/search-vehicle?vehicleId=${vehicleId}&catalog=${brand}&ssd=${vehicleSsd}`;
        }
    }, [vehicleId, vehicleSsd]);

    return children;
};